module.exports = __webpack_public_path__ + "static/media/4.17f80134.gif";